"use strict";
module.exports = {
    
    configure : function(module) {
        module.config(["$stateProvider", function ($stateProvider) {
            
        }]);
    }

};